import { render } from "./AzerbaijanPage.vue?vue&type=template&id=2ff8492a&scoped=true"
import script from "./AzerbaijanPage.vue?vue&type=script&lang=js"
export * from "./AzerbaijanPage.vue?vue&type=script&lang=js"

import "./AzerbaijanPage.vue?vue&type=style&index=0&id=2ff8492a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff8492a"]])

export default __exports__